export const enumeratedLifeCycle = [
  'readStatus',
  'readErrors',
  'updateStatus',
  'updateErrors',
  'isDirty',
];

export const saveLifeCycle = [
  'saveStatus',
  'saveErrors',
];

export const defaultLifeCycle = [
  'createStatus',
  'createErrors',
  'destroyStatus',
  'destroyErrors',
  ...saveLifeCycle,
  ...enumeratedLifeCycle,
];

export const states = {
  PENDING: 'PENDING',
  APPENDING: 'APPENDING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  NONE: null,
};

/**
 * @deprecated Do not use this. Use `saveStates` instead
 */
export const createStates = {
  createStatus: states.NONE,
  createErrors: [],
};

export const readStates = {
  readStatus: states.NONE,
  readErrors: [],
};

/**
 * @deprecated Do not use this. Use `saveStates` instead
 */
export const updateStates = {
  updateStatus: states.NONE,
  updateErrors: [],
};

export const destroyStates = {
  destroyStatus: states.NONE,
  destroyErrors: [],
};

export const saveStates = {
  saveStatus: states.NONE,
  saveErrors: [],
};

const defaultStates = {
  ...createStates,
  ...readStates,
  ...updateStates,
  ...destroyStates,
};

export const subscribeStates = {
  subscriptionsStatus: states.NONE,
  subscriptionsErrors: [],
};

export default defaultStates;
